import React from 'react'
import { isNil } from 'lodash-es'
import styled from '@emotion/styled'
import { RemoveItemButton } from 'view/components/options/optionsStyles'
import { iconSet } from 'view/components/icons'
import { TypedCellRendererParams } from '../gridUtils'

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export class DeleteButtonRenderer<T> extends React.Component<TypedCellRendererParams<T>> {
  render() {
    const { context, node } = this.props

    return (
      <ButtonWrapper>
        <RemoveItemButton
          dataTestId={'CollateralBasketSelectedProductsGrid-RemoveItemButton'}
          onClick={() => !isNil(node.id) && context.updateCellValue(node.id, node.data, 'deleteButtonField', true)}>
          {iconSet.crossIcon}
        </RemoveItemButton>
      </ButtonWrapper>
    )
  }

  refresh = () => {
    this.forceUpdate()
    return true
  }
}
